import { extractHexColor } from "styles/hexOpacity";
import { theme } from "styles/theme";

export const LockIconSvg = ({ color = "currentColor" }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.2568 1.67383C12.8989 1.80753 15 3.99172 15 6.66699V8.34863C15.4367 8.37 15.7372 8.42235 15.9912 8.55176C16.3675 8.74351 16.6735 9.04949 16.8652 9.42578C17.0831 9.85355 17.083 10.4134 17.083 11.5332V15.1338C17.083 16.2536 17.0832 16.8134 16.8652 17.2412C16.6735 17.6175 16.3675 17.9235 15.9912 18.1152C15.5634 18.3332 15.0036 18.333 13.8838 18.333H6.11621C4.99644 18.333 4.43655 18.3332 4.00879 18.1152C3.63246 17.9235 3.32651 17.6175 3.13477 17.2412C2.91683 16.8134 2.91699 16.2536 2.91699 15.1338V11.5332C2.91699 10.4134 2.91694 9.85355 3.13477 9.42578C3.3265 9.04949 3.63251 8.74351 4.00879 8.55176C4.26277 8.42235 4.56329 8.37 5 8.34863V6.66699C5 3.90557 7.23858 1.66699 10 1.66699L10.2568 1.67383ZM10 3.66699C8.34315 3.66699 7 5.01014 7 6.66699V8.33301H13V6.66699C13 5.01014 11.6569 3.66699 10 3.66699Z"
        fill={color}
      />
    </svg>
  );
};
export const XMarkIconSvg = ({ color = "currentColor" }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 5L5 15"
        stroke={color}
        stroke-width="1.6"
        stroke-linecap="round"
      />
      <path
        d="M15 15L5 5"
        stroke={color}
        stroke-width="1.6"
        stroke-linecap="round"
      />
    </svg>
  );
};
export const KeypadDeleteIconSvg = ({ color = "currentColor" }) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2808_3278)">
        <path
          d="M21.8333 4H8.83325L1.83325 12L8.83325 20H21.8333C22.3637 20 22.8724 19.7893 23.2475 19.4142C23.6225 19.0391 23.8333 18.5304 23.8333 18V6C23.8333 5.46957 23.6225 4.96086 23.2475 4.58579C22.8724 4.21071 22.3637 4 21.8333 4Z"
          stroke={color}
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18.8333 9L12.8333 15"
          stroke={color}
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.8333 9L18.8333 15"
          stroke={color}
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2808_3278">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.833252)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const SearchIconSvg = ({ color = "currentColor" }) => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.16667 16.3333C12.8486 16.3333 15.8333 13.3486 15.8333 9.66667C15.8333 5.98477 12.8486 3 9.16667 3C5.48477 3 2.5 5.98477 2.5 9.66667C2.5 13.3486 5.48477 16.3333 9.16667 16.3333Z"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.5 18L13.875 14.375"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const ShieldIconSvg = ({ color = "currentColor" }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 18.3333C10 18.3333 16.6667 15 16.6667 10V4.16667L10 1.66667L3.33337 4.16667V10C3.33337 15 10 18.3333 10 18.3333Z"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const HeadphoneIconSvg = ({ color = "currentColor" }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.5 15V10C2.5 8.01088 3.29018 6.10322 4.6967 4.6967C6.10322 3.29018 8.01088 2.5 10 2.5C11.9891 2.5 13.8968 3.29018 15.3033 4.6967C16.7098 6.10322 17.5 8.01088 17.5 10V15"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.5 15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H15C14.558 17.5 14.134 17.3244 13.8215 17.0118C13.5089 16.6993 13.3333 16.2754 13.3333 15.8333V13.3333C13.3333 12.8913 13.5089 12.4674 13.8215 12.1548C14.134 11.8423 14.558 11.6667 15 11.6667H17.5V15.8333ZM2.5 15.8333C2.5 16.2754 2.67559 16.6993 2.98816 17.0118C3.30072 17.3244 3.72464 17.5 4.16667 17.5H5C5.44203 17.5 5.86595 17.3244 6.17851 17.0118C6.49107 16.6993 6.66667 16.2754 6.66667 15.8333V13.3333C6.66667 12.8913 6.49107 12.4674 6.17851 12.1548C5.86595 11.8423 5.44203 11.6667 5 11.6667H2.5V15.8333Z"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const BellIconSvg = ({ color = "currentColor" }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 6.66667C15 5.34059 14.4732 4.06882 13.5355 3.13114C12.5979 2.19346 11.3261 1.66667 10 1.66667C8.67392 1.66667 7.40215 2.19346 6.46447 3.13114C5.52678 4.06882 5 5.34059 5 6.66667C5 12.5 2.5 14.1667 2.5 14.1667H17.5C17.5 14.1667 15 12.5 15 6.66667Z"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.4417 17.5C11.2952 17.7526 11.0849 17.9622 10.8319 18.1079C10.5789 18.2537 10.292 18.3304 10 18.3304C9.70803 18.3304 9.42117 18.2537 9.16816 18.1079C8.91515 17.9622 8.70486 17.7526 8.55835 17.5"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const CardIconSvg = ({ color = "currentColor" }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_3529_524)">
        <path
          d="M17.5 3.33333H2.50004C1.57957 3.33333 0.833374 4.07953 0.833374 5V15C0.833374 15.9205 1.57957 16.6667 2.50004 16.6667H17.5C18.4205 16.6667 19.1667 15.9205 19.1667 15V5C19.1667 4.07953 18.4205 3.33333 17.5 3.33333Z"
          stroke={color}
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M0.833374 8.33333H19.1667"
          stroke={color}
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3529_524">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const MyProfileIconSvg = ({ color = "currentColor" }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.6667 17.5V15.8333C16.6667 14.9493 16.3155 14.1014 15.6904 13.4763C15.0653 12.8512 14.2174 12.5 13.3334 12.5H6.66671C5.78265 12.5 4.93481 12.8512 4.30968 13.4763C3.68456 14.1014 3.33337 14.9493 3.33337 15.8333V17.5"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.99996 9.16667C11.8409 9.16667 13.3333 7.67428 13.3333 5.83333C13.3333 3.99238 11.8409 2.5 9.99996 2.5C8.15901 2.5 6.66663 3.99238 6.66663 5.83333C6.66663 7.67428 8.15901 9.16667 9.99996 9.16667Z"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const ResetIconSvg = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2441_1646)">
        <path
          d="M19.1667 3.83334V8.83334H14.1667"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M0.833344 17.1667V12.1667H5.83334"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M2.92501 8.00001C3.34765 6.80567 4.06595 5.73785 5.0129 4.89619C5.95984 4.05454 7.10456 3.46648 8.34025 3.18689C9.57593 2.9073 10.8623 2.9453 12.0793 3.29732C13.2964 3.64935 14.4044 4.30394 15.3 5.20001L19.1667 8.83334M0.833344 12.1667L4.70001 15.8C5.59563 16.6961 6.70365 17.3507 7.92068 17.7027C9.13771 18.0547 10.4241 18.0927 11.6598 17.8131C12.8955 17.5335 14.0402 16.9455 14.9871 16.1038C15.9341 15.2622 16.6524 14.1944 17.075 13"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2441_1646">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const UndoneIconSvg = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.50001 12.1667L3.33334 8.00001L7.50001 3.83334"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.6667 17.1667V11.3333C16.6667 10.4493 16.3155 9.60143 15.6904 8.97631C15.0652 8.35119 14.2174 8 13.3333 8H3.33334"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const TrashIconSvg = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.5 5.5H4.16667H17.5"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.8333 5.49999V17.1667C15.8333 17.6087 15.6577 18.0326 15.3452 18.3452C15.0326 18.6577 14.6087 18.8333 14.1667 18.8333H5.83332C5.3913 18.8333 4.96737 18.6577 4.65481 18.3452C4.34225 18.0326 4.16666 17.6087 4.16666 17.1667V5.49999M6.66666 5.49999V3.83332C6.66666 3.3913 6.84225 2.96737 7.15481 2.65481C7.46737 2.34225 7.8913 2.16666 8.33332 2.16666H11.6667C12.1087 2.16666 12.5326 2.34225 12.8452 2.65481C13.1577 2.96737 13.3333 3.3913 13.3333 3.83332V5.49999"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const CheckIconSvgSelectedButton = ({ color = "currentColor" }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 9.03846L8.52941 14.1667L15 5.83333"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const CheckIconSvgDoneButton = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 7.23085L6.82353 11.3334L12 4.66675"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const CheckIconSvg = () => {
  return (
    <svg
      width="12"
      height="10"
      viewBox="0 0 12 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.75 4.25L4.75 8.25L10.25 1.75"
        stroke="white"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const CommentArrowSvg = () => {
  const color = extractHexColor(theme.vars.palette.primary.solid);
  return (
    <svg
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.65 5.5C4.65 5.14101 4.35899 4.85 4 4.85C3.64101 4.85 3.35 5.14101 3.35 5.5H4.65ZM17 16.5L10.5 12.7472V20.2528L17 16.5ZM3.35 5.5V11.5H4.65V5.5H3.35ZM9 17.15H11.15V15.85H9V17.15ZM3.35 11.5C3.35 14.6204 5.87959 17.15 9 17.15V15.85C6.59756 15.85 4.65 13.9024 4.65 11.5H3.35Z"
        fill={color}
      />
    </svg>
  );
};
export const RightArrowSvg = ({ color = "currentColor" }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.29169 15.4165L12.7084 9.99984L7.29169 4.58317"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const NextArrowSvg = ({ color }) => {
  return (
    <svg
      width="14"
      height="12"
      viewBox="0 0 14 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.47186 10.5136C7.68951 11.7736 5.85601 11.7736 5.07366 10.5136L0.442448 3.05502C-0.384807 1.72272 0.573314 1.26122e-06 2.14155 1.12412e-06L11.404 3.14375e-07C12.9722 1.77276e-07 13.9303 1.72272 13.1031 3.05501L8.47186 10.5136Z"
        fill={color}
      />
    </svg>
  );
};

export const DownArrowSvg = ({ color }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_3202_346)">
        <path
          d="M11.9399 13.3066C11.3033 14.4093 10.985 14.9606 10.5695 15.1456C10.207 15.307 9.79308 15.307 9.43061 15.1456C9.01505 14.9606 8.69675 14.4093 8.06014 13.3066L4.72306 7.52663C4.08646 6.424 3.76815 5.87268 3.8157 5.42029C3.85718 5.02569 4.06414 4.66722 4.38513 4.434C4.75315 4.16663 5.38975 4.16663 6.66296 4.16663L13.3371 4.16663C14.6103 4.16663 15.2469 4.16663 15.6149 4.434C15.9359 4.66722 16.1429 5.02569 16.1844 5.42029C16.2319 5.87268 15.9136 6.424 15.277 7.52663L11.9399 13.3066Z"
          fill="#0F55A7"
        />
      </g>
      <defs>
        <clipPath id="clip0_3202_346">
          <rect width="20" height="20" rx="3" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const UpArrowSvg = ({ color = "currentColor" }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.25016 12.6919L4.92291 7.78764C4.46712 7.27108 4.83389 6.45834 5.52278 6.45834L14.4772 6.45834C15.1661 6.45834 15.5329 7.27108 15.0771 7.78764L10.7498 12.6919C10.3517 13.143 9.64825 13.143 9.25016 12.6919Z"
        fill={color}
      />
    </svg>
  );
};

export const LogoWithTextSvg = () => {
  return (
    <svg
      width="138"
      height="28"
      viewBox="0 0 138 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M125.017 9.50624C125.811 9.50624 126.529 9.65536 127.169 9.95644L130.937 9.78554L130.926 12.0267L129.147 11.9877C129.263 12.3139 129.321 12.6614 129.321 13.0287C129.321 13.683 129.13 14.2826 128.75 14.8236C128.377 15.3569 127.864 15.7796 127.217 16.0922C126.568 16.4059 125.833 16.5609 125.017 16.5609C124.752 16.5609 124.495 16.5449 124.248 16.5131C124.006 16.5678 123.836 16.6431 123.727 16.7318C123.62 16.8188 123.576 16.9144 123.576 17.0228C123.576 17.0912 123.595 17.147 123.631 17.1947C123.67 17.2442 123.732 17.2926 123.829 17.3344C124.037 17.4217 124.359 17.4862 124.801 17.5238L126.417 17.6576C127.211 17.7216 127.9 17.8523 128.479 18.0531C129.068 18.2549 129.527 18.5448 129.848 18.9281C130.18 19.3164 130.341 19.8074 130.341 20.39C130.341 20.8842 130.204 21.3452 129.933 21.7709C129.663 22.1951 129.28 22.5595 128.789 22.8656C128.303 23.172 127.723 23.4082 127.051 23.5756C126.378 23.7497 125.634 23.8363 124.819 23.8363C124.106 23.8363 123.461 23.7721 122.883 23.643C122.307 23.5204 121.809 23.3387 121.392 23.0961H121.391C120.98 22.8533 120.66 22.5581 120.433 22.2094H120.432C120.21 21.8643 120.1 21.4752 120.1 21.0463C120.1 20.6992 120.192 20.3722 120.374 20.0678L120.375 20.0658L120.376 20.0648C120.564 19.7666 120.835 19.5123 121.182 19.3012C121.462 19.1295 121.787 18.9943 122.158 18.8939C121.909 18.7318 121.712 18.5519 121.57 18.3529C121.377 18.0831 121.282 17.7745 121.282 17.432C121.282 17.1276 121.368 16.8411 121.538 16.5746L121.539 16.5736V16.5726C121.713 16.3087 121.957 16.0746 122.264 15.8705C122.284 15.8573 122.304 15.8443 122.325 15.8314C121.9 15.5587 121.546 15.2259 121.267 14.8334L121.135 14.6293C120.849 14.1461 120.706 13.6116 120.706 13.0287C120.706 12.3684 120.896 11.7689 121.277 11.2338C121.656 10.7009 122.171 10.2812 122.818 9.97499C123.467 9.66149 124.201 9.50629 125.017 9.50624ZM124.187 19.6615C123.823 19.6928 123.517 19.7601 123.27 19.8607C123.02 19.9626 122.838 20.0917 122.716 20.2416C122.595 20.3975 122.536 20.5661 122.536 20.7514C122.536 20.9782 122.625 21.1769 122.816 21.3519C123.017 21.5371 123.309 21.6875 123.701 21.7982C124.09 21.9083 124.559 21.9652 125.112 21.9652C125.977 21.9652 126.645 21.8363 127.124 21.5892L127.125 21.5883C127.606 21.3459 127.811 21.0547 127.811 20.723C127.811 20.5879 127.776 20.4728 127.71 20.3734C127.642 20.2732 127.538 20.1821 127.388 20.1039C127.083 19.9506 126.602 19.8446 125.934 19.7943L124.187 19.6615ZM125.017 11.5014C124.629 11.5014 124.291 11.5688 124.002 11.6996C123.711 11.8308 123.488 12.0103 123.326 12.2367C123.172 12.4604 123.093 12.7228 123.093 13.0287C123.093 13.4774 123.268 13.8404 123.623 14.1273C123.98 14.4099 124.441 14.556 125.017 14.556C125.399 14.556 125.734 14.4897 126.024 14.3588C126.315 14.2275 126.539 14.0473 126.701 13.8207C126.861 13.5897 126.942 13.3268 126.942 13.0287C126.942 12.573 126.767 12.2101 126.414 11.9301L126.41 11.9281H126.397L126.388 11.9105C126.035 11.6405 125.58 11.5014 125.017 11.5014Z"
        fill="#20272B"
      />
      <path
        d="M112.468 10.7067C112.805 10.3309 113.186 10.0476 113.613 9.85953C114.139 9.62421 114.689 9.50634 115.261 9.50634C116.147 9.50634 116.889 9.68389 117.481 10.0479C118.072 10.4076 118.515 10.8714 118.804 11.4397C119.09 12.0024 119.233 12.5928 119.233 13.2095V19.5566H116.562V13.9704C116.562 13.3495 116.384 12.8707 116.04 12.5189C115.698 12.1688 115.215 11.9863 114.571 11.9863C114.156 11.9863 113.791 12.0799 113.472 12.2643L113.471 12.2646C113.159 12.4428 112.914 12.6947 112.736 13.0232C112.558 13.3506 112.468 13.7317 112.468 14.1701V19.5566H109.796V9.79165H112.468V10.7067Z"
        fill="#20272B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M105.032 19.5566V9.79165H107.704V19.5566H105.032ZM105.208 8.01751C104.875 7.72491 104.711 7.33686 104.711 6.86607C104.711 6.39528 104.875 6.00723 105.208 5.71463C105.534 5.42727 105.923 5.2837 106.368 5.2837C106.813 5.2837 107.202 5.42727 107.528 5.71463C107.861 6.00723 108.025 6.39528 108.025 6.86607C108.025 7.33686 107.861 7.72491 107.528 8.01751C107.202 8.30487 106.813 8.44844 106.368 8.44844C105.923 8.44844 105.534 8.30487 105.208 8.01751Z"
        fill="#20272B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M97.3737 19.1694L97.3732 19.1691C96.5798 18.7146 95.9527 18.1 95.494 17.3262L95.4938 17.3258C95.034 16.5436 94.8053 15.6586 94.8053 14.6742C94.8053 13.9293 94.9405 13.2429 95.2127 12.6167C95.484 11.9861 95.8655 11.4392 96.3569 10.977C96.8481 10.5087 97.4229 10.1482 98.0801 9.89527C98.7447 9.63551 99.4659 9.50634 100.242 9.50634C100.915 9.50634 101.542 9.59663 102.122 9.77838C102.704 9.96044 103.237 10.2402 103.721 10.6171L103.811 10.6872L102.548 12.7495L102.435 12.6482C102.152 12.3935 101.83 12.2058 101.468 12.0844L101.467 12.084L101.466 12.0836C101.108 11.9555 100.732 11.8912 100.337 11.8912C99.7348 11.8912 99.2231 12.0024 98.7972 12.2197C98.3783 12.4366 98.0567 12.7486 97.8296 13.1575C97.6031 13.5656 97.4866 14.0661 97.4866 14.6646C97.4866 15.5513 97.7426 16.2317 98.2417 16.7224C98.7482 17.2079 99.4414 17.4571 100.337 17.4571C100.78 17.4571 101.199 17.3745 101.592 17.21C101.987 17.0448 102.33 16.819 102.62 16.5329L102.735 16.419L103.952 18.5028L103.861 18.5709C103.334 18.9658 102.746 19.2761 102.098 19.5021C101.448 19.7285 100.786 19.842 100.11 19.842C99.0894 19.842 98.1764 19.6189 97.3743 19.1697L97.3737 19.1694Z"
        fill="#20272B"
      />
      <path
        d="M86.8262 10.7067C87.1629 10.3309 87.5446 10.0476 87.9716 9.85953C88.4978 9.62421 89.0475 9.50634 89.6195 9.50634C90.505 9.50634 91.2476 9.68389 91.8396 10.0479C92.4308 10.4076 92.8732 10.8714 93.1621 11.4397C93.4482 12.0024 93.5918 12.5928 93.5918 13.2095V19.5566H90.9199V13.9704C90.9199 13.3495 90.7423 12.8707 90.3987 12.5189C90.0566 12.1688 89.5729 11.9863 88.9298 11.9863C88.5147 11.9863 88.1495 12.0799 87.8305 12.2643L87.8298 12.2646C87.5171 12.4428 87.2723 12.6947 87.0943 13.0232C86.9168 13.3506 86.8262 13.7317 86.8262 14.1701V19.5566H84.1544V9.79165H86.8262V10.7067Z"
        fill="#20272B"
      />
      <path
        d="M77.7379 9.41112C78.6326 9.41112 79.4129 9.55251 80.0748 9.83983C80.7462 10.1286 81.2647 10.5742 81.6255 11.1748C81.9937 11.7708 82.1734 12.5216 82.1734 13.4189V19.5566H79.7847V18.6992C79.4839 19.0239 79.1068 19.2839 78.6568 19.4795V19.4805C78.0849 19.7225 77.4439 19.8417 76.7369 19.8418C76.078 19.8418 75.4879 19.7151 74.9703 19.458C74.453 19.201 74.0441 18.8369 73.7476 18.3662V18.3652C73.4497 17.8855 73.3023 17.3221 73.3023 16.6806C73.3023 16.1258 73.4409 15.6259 73.7193 15.1855C73.9989 14.7435 74.4254 14.3839 74.9888 14.1035C75.5543 13.8158 76.2691 13.6264 77.1285 13.5303C77.8452 13.4507 78.6685 13.4458 79.5963 13.5146V13.4473C79.5962 13.0665 79.5146 12.7443 79.358 12.4756L79.357 12.4736V12.4726C79.2076 12.2008 78.9763 11.9902 78.6578 11.8418L78.6568 11.8408L78.5328 11.7861C78.2331 11.6676 77.8563 11.6055 77.398 11.6055C76.9198 11.6055 76.4436 11.6796 75.9703 11.8281V11.8291C75.5059 11.9705 75.0678 12.1916 74.6568 12.4941L74.522 12.5928L73.7759 10.6015L73.8599 10.5449C74.4695 10.138 75.1128 9.84676 75.7886 9.67186C76.4591 9.49835 77.109 9.41113 77.7379 9.41112ZM78.2134 15.2676C77.6475 15.2801 77.1844 15.3454 76.8218 15.4609C76.4642 15.5769 76.206 15.7318 76.0367 15.9189C75.8749 16.1046 75.7955 16.3188 75.7955 16.5664C75.7955 16.9491 75.9312 17.233 76.1978 17.4346C76.4714 17.6349 76.8542 17.7422 77.3599 17.7422C77.7914 17.7422 78.1727 17.6627 78.5064 17.5068H78.5074C78.8476 17.3506 79.1125 17.1329 79.3062 16.8555C79.4977 16.5749 79.5962 16.2427 79.5963 15.8535V15.3437C79.083 15.2836 78.6219 15.2585 78.2134 15.2676Z"
        fill="#20272B"
      />
      <path
        d="M69.5535 12.0244V15.863C69.5535 16.4607 69.6721 16.8504 69.8773 17.0682C70.0875 17.285 70.3823 17.4 70.7783 17.4C70.9825 17.4 71.173 17.3758 71.3504 17.3282L71.3509 17.3281L71.3514 17.328C71.5389 17.2793 71.71 17.2157 71.8651 17.1376L72.0137 17.0628L72.4418 19.2604L72.3582 19.3044C72.0713 19.4553 71.738 19.582 71.3594 19.6854C70.9765 19.7899 70.5779 19.842 70.1641 19.842C69.1688 19.842 68.3657 19.5549 67.7701 18.9688C67.1702 18.3784 66.8816 17.4964 66.8816 16.348V12.0244H64.8879V9.79165H66.8816V7.03362H69.5535V9.79165H72.0386V12.0244H69.5535Z"
        fill="#20272B"
      />
      <path
        d="M57.8586 19.4937L57.8583 19.4936C57.1533 19.2678 56.5501 18.9569 56.0511 18.5591L55.9713 18.4954L56.9227 16.5373L57.0442 16.6249C57.5002 16.9536 58.0028 17.2144 58.5524 17.4071C59.1011 17.5995 59.6351 17.6948 60.1549 17.6948C60.7104 17.6948 61.1254 17.6012 61.4128 17.4277C61.6933 17.2582 61.8238 17.0314 61.8238 16.7379C61.8238 16.5949 61.7933 16.4777 61.7373 16.3815C61.6813 16.2854 61.5955 16.2031 61.474 16.1364C61.2149 15.9942 60.7092 15.8387 59.9406 15.6738C58.7112 15.4313 57.7984 15.071 57.2199 14.5813L57.2193 14.5808C56.6328 14.0777 56.3433 13.3871 56.3433 12.5248C56.3433 11.9103 56.5113 11.364 56.849 10.8908L56.8493 10.8903L56.8497 10.8899C57.1919 10.4195 57.6579 10.0575 58.2429 9.80228C58.8348 9.54046 59.5108 9.41123 60.2683 9.41123C61.0046 9.41123 61.7008 9.51435 62.3565 9.72135C63.0178 9.92816 63.5894 10.2201 64.0693 10.5986L64.1482 10.6609L63.233 12.6441L63.1064 12.5363C62.8696 12.3347 62.5985 12.1597 62.2924 12.0118C61.9861 11.8638 61.661 11.7496 61.3169 11.6692L61.3164 11.6691C60.9791 11.5888 60.6455 11.5488 60.3156 11.5488C59.8319 11.5488 59.4527 11.6353 59.1693 11.7981C58.9019 11.9553 58.779 12.166 58.779 12.4392C58.779 12.5816 58.81 12.6996 58.8676 12.7976C58.9252 12.8953 59.0133 12.9802 59.1382 13.0502C59.4055 13.1934 59.9035 13.3519 60.6453 13.5228C61.9107 13.7967 62.8355 14.1632 63.4009 14.6331C63.9762 15.1111 64.2595 15.7805 64.2595 16.6238C64.2595 17.2696 64.0855 17.8384 63.7345 18.3248L63.734 18.3255C63.3849 18.8029 62.8996 19.1741 62.2838 19.4416L62.2833 19.4419C61.6724 19.7035 60.9651 19.8324 60.1644 19.8324C59.3403 19.8324 58.5714 19.7199 57.8586 19.4937Z"
        fill="#20272B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M51.9669 19.5566V9.79165H54.6388V19.5566H51.9669ZM52.1424 8.01751C51.8101 7.72491 51.6456 7.33686 51.6456 6.86607C51.6456 6.39528 51.8101 6.00723 52.1424 5.71463C52.4687 5.42727 52.8576 5.2837 53.3028 5.2837C53.7481 5.2837 54.137 5.42727 54.4633 5.71463C54.7955 6.00723 54.96 6.39528 54.96 6.86607C54.96 7.33686 54.7955 7.72491 54.4633 8.01751C54.137 8.30487 53.7481 8.44844 53.3028 8.44844C52.8576 8.44844 52.4687 8.30487 52.1424 8.01751Z"
        fill="#20272B"
      />
      <path
        d="M49.8668 19.5569H47.4781V18.5002C47.2216 18.7754 46.9204 19.0201 46.5748 19.2336C45.9138 19.642 45.092 19.842 44.1177 19.842C43.1779 19.842 42.3394 19.6211 41.606 19.177C40.874 18.7336 40.2999 18.1205 39.8863 17.3401C39.4721 16.5585 39.2672 15.6685 39.2672 14.6741C39.2672 14.0459 39.3558 13.4532 39.5338 12.8967L39.6158 12.6604C39.8543 12.0311 40.19 11.481 40.6236 11.0119C41.0637 10.5364 41.5822 10.168 42.1773 9.90746C42.7746 9.63961 43.4348 9.50609 44.1558 9.50609C44.9854 9.50609 45.718 9.67495 46.3502 10.0159C46.6536 10.1765 46.9356 10.3694 47.1949 10.595V5.60667H49.8668V19.5569ZM44.5621 11.8909C44.0458 11.8909 43.5883 12.0039 43.1871 12.2268C42.7932 12.4491 42.4828 12.7677 42.2545 13.1848C42.0333 13.6003 41.9205 14.0952 41.9205 14.6741C41.9205 15.2525 42.0362 15.7471 42.2632 16.1623C42.4916 16.5734 42.8029 16.8922 43.1978 17.1213C43.5923 17.3437 44.0459 17.4572 44.5621 17.4573C45.0719 17.4573 45.5227 17.3441 45.9175 17.1213C46.3189 16.8921 46.6328 16.5731 46.8609 16.1623C47.088 15.7471 47.2047 15.2525 47.2047 14.6741C47.2046 14.0956 47.088 13.601 46.8609 13.1858C46.6324 12.7682 46.3216 12.4493 45.9273 12.2268C45.5327 12.0041 45.0786 11.8909 44.5621 11.8909Z"
        fill="#20272B"
      />
      <path
        d="M23.7968 20.0163L26.6137 22.8409C26.9429 23.1711 27.3887 23.3564 27.8535 23.3564C28.5002 23.3564 29.0245 22.8287 29.0245 22.1778V19.8706C29.0245 19.6948 29.1661 19.5524 29.3407 19.5524H32.9445C33.9223 19.5524 34.7149 18.7546 34.7149 17.7706V11.8241C34.7149 10.84 33.9223 10.0423 32.9445 10.0423H29.3109C29.1527 10.0423 29.0245 9.91326 29.0245 9.7541C29.0245 8.8628 28.3067 8.14026 27.4211 8.14026H19.827C19.6689 8.14026 19.5407 8.01124 19.5407 7.85208C19.5407 6.96078 18.8228 6.23824 17.9372 6.23824H11.8271C10.8494 6.23824 10.0568 7.03599 10.0568 8.02006V9.7241C10.0568 9.89983 9.91526 10.0423 9.74066 10.0423H8.03357C7.05585 10.0423 6.26324 10.84 6.26324 11.8241V17.7706C6.26324 18.7546 7.05584 19.5524 8.03357 19.5524H22.6812C23.0994 19.5524 23.5006 19.7192 23.7968 20.0163Z"
        fill="#20272B"
      />
    </svg>
  );
};

export const DoubleLeftArrowSvg = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5">
        <rect width="24" height="24" rx="3" fill="none" />
        <path
          d="M18.1665 5.5L11.6665 12L18.1665 18.5"
          stroke="#2E2B2B"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLineJoin="round"
        />
        <path
          d="M11.5 5.5L5 12L11.5 18.5"
          stroke="#2E2B2B"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLineJoin="round"
        />
      </g>
    </svg>
  );
};

export const LeftArrow = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5">
        <path
          d="M15 5.5L8.5 12L15 18.5"
          stroke="#2E2B2B"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export const RightArrow = () => {
  return (
    <div style={{ transform: "scaleX(-1)" }}>
      <LeftArrow />
    </div>
  );
};
